import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import router from './router/index'
// import Vue3Autocounter from 'vue3-autocounter'

createApp(App).use(Antd).use(router).mount('#app')
// .component('vue3-autocounter', Vue3Autocounter)